export enum SharepointStatusType {
  NotConnected = 'NOT_CONNECTED',
  Connected = 'CONNECTED',
  AuthorizedConfigurationRequired = 'AUTHORIZED_CONFIGURATION_REQUIRED',
  AuthorizedValidationError = 'AUTHORIZED_VALIDATION_ERROR',
  AuthenticationError = 'AUTHENTICATION_ERROR',
}

export const SharepointErrorStatusTypes = [
  SharepointStatusType.AuthorizedConfigurationRequired,
  SharepointStatusType.AuthorizedValidationError,
  SharepointStatusType.AuthenticationError,
];
